import React, { useState, useEffect, useImperativeHandle, forwardRef, useRef } from 'react';
import * as sdk from 'microsoft-cognitiveservices-speech-sdk';
import toWav from 'audiobuffer-to-wav';
import { Buffer } from 'buffer';
import axios from 'axios';
import { useUserAuth } from "../context/UserAuthContext";
import { title } from 'process';
// import { start } from 'repl';

const CHUNK_SIZE = 2 * 1024 * 1024; // 2MB
const MAX_RETRY = 5;

const OfflineTranscription = forwardRef((props, ref) => {
  const { createHistory, setAudioName, endTimeOfLocalSave, realtimeValue, saveAudioLocally } = props; //the name of uploaded file(audio blob) to server, delete file from server(from uploads folder) need it 
  // const [url, setUrl] = useState(null);  //the url of uploaded file(audio blob) to server, batch transcribe need it
  const [transcription, setTranscription] = useState({
    text: '',
    transcribeID: '',
    url: '',
    videoURL: '', 
    videoID: '',
    title: '',
    duration: 0,
    subtitleWithTimestamp: ''
  });
  const [error, setError] = useState(null);
  const [uploadedFileName, setUploadedFileName] = useState(''); 

  //_______________________________________________________________________________________
  const [isTranscribing, setIsTranscribing] = useState(false);

  const [duration, setDuration] = useState(0);
  const [progressOfUpload, setProgressOfUpload] = useState(0);
  const [progressOfTranscription, setProgressOfTranscription] = useState(0);
  const sdk = require("microsoft-cognitiveservices-speech-sdk");
  const [uploading, setUploading] = useState(false);
  const [progressStatus, setProgressStatus] = useState('');
  const [messageShowToUser, setMessageShowToUser] = useState('Drag and drop an audio file here.');

  const { user, userDataLocal, setTaskIDOfOfflinetranscribe, updateTranscriptionData, fetchTrascriptionData, updateVideoData, checkToken } = useUserAuth();
  const [endTimeOfAudio, setEndTimeOfAudio] = useState(null);  //2024.09.06 add for record the end time of audio file
  const [realTimeFlag, setRealTimeFlag] = useState(false);

  const [transcribeData, setTranscribeData] = useState({
    ID: '',
    url: '',
    inputValue: '',
    noteIDnum: '',
    duration: 0,
  });

  //2025.02.23
  const [isPaused, setIsPaused] = useState(false);
  const controllerRef = useRef(null);
  const uploadedChunksRef = useRef([]);

  //begin upload the file user selected/droped to server and get the url of the file
  //Now not't handle upload a new file when the previous file is still uploading
  //_______________________________________________________________________________________
  //Running logic:
  //setAudioFileUserUploadArray => preCheckAudioFile(audioFile)  => setAudioFileUserUpload => 
  //handleUpload() => setUrl => startBatchTranscribe() => setIsTranscribing => 
  //setAudioFileUserUploadArray(remove the first element)
  //_______________________________________________________________________________________

  useEffect(() => {
    if(isTranscribing){
      setMessageShowToUser(`Processing the file, please wait`);
    } else if (!isTranscribing) {
      if(transcription.text !== '') {
        // console.log('All the file uploaded done! audioFileUserUploadArray is empty!');
        setMessageShowToUser('Transcribe task have been done.');
      }
      setProgressOfUpload(0);
      setError('');
      setUploading(false);
    }
  }, [isTranscribing]);

  //2024.05.31 update usage and transcription to parent component
  useEffect(() => {
    let delaySet = null;
    const fetchDataAndUpdate = async () => {
      if (transcription.text !== '' && transcription.transcribeID) {
        let speakerTranscrition = transcription.text;
        let subtitleWithTimestamp = transcription.subtitleWithTimestamp;
        let transcribeID = transcription.transcribeID;
        let history = userDataLocal.History;
        let note = history.find((item) => item.transcribeID === transcribeID);
        //const { transcript, polishedText, summary, noteID, gptresponse, transcribeID, inputValue } = note;
        const videoID = transcription?.videoID;
        const videoURL = transcription?.videoURL;
        if (transcription?.videoID && transcription?.videoURL) {
          const newVideoData = { 
            Transcript: speakerTranscrition,
            subtitleWithTimestamp: subtitleWithTimestamp
          }
          updateVideoData(videoID, newVideoData);
        }
        const noteID = note?.noteID;
        if (!noteID) {
          console.error('The noteID is undefined.');
          // return;
          if (transcription.duration !== 0 && transcribeID !== '') {
            let usageSum = Math.round(transcription.duration / 60 * 100) / 100;
            if (usageSum < 1) usageSum = 1;
            let endTime = endTimeOfAudio;
            let realtimeBoolValue = realTimeFlag;
            let url = transcription.url;
            let inputValue = speakerTranscrition;
            let noteIDnum = '';
            let polishedText = '';
            let title = transcription.title;
            createHistory(inputValue, usageSum, endTime, realtimeBoolValue, transcribeID, url, noteIDnum, videoURL, videoID, polishedText, title, subtitleWithTimestamp);
          }
        } else {
          try {
            const noteData = await fetchTrascriptionData(noteID);
            if(noteData && noteData?.transcribeID && noteData?.transcribeID !== 'Done' && (speakerTranscrition !=='Transcript updating...' && subtitleWithTimestamp)){
              const inputValueOfTandP = noteData.inputValue;
              const newNote = {
                ...noteData,
                inputValue: inputValueOfTandP === 'Transcript updating...' ? speakerTranscrition : inputValueOfTandP,
                transcript: speakerTranscrition,  
                subtitleWithTimestamp: subtitleWithTimestamp,
                transcribeID: 'Done'
              };
              updateTranscription('', '', '', '', '', '', '', 0, '');
              updateTranscriptionData(newNote);
            } 
            // const newNote = {
            //   transcript: speakerTranscrition,
            //   polishedText: noteData.polishedText,
            //   summary: noteData.summary,
            //   noteID: noteData.noteID,
            //   gptresponse: noteData.gptresponse,
            //   transcribeID: noteData.transcribeID, 
            //   inputValue: noteData.inputValue
            // };
          } catch (error) {
            console.error('Error fetching transcription data:', error);
          }
        }
      }
    };
    fetchDataAndUpdate();
    return () => {
      if (delaySet) clearTimeout(delaySet);
    };
  }, [transcription]);

  useEffect(() => {
    let delaySet = null;
    let audiofilenameofCloud = uploadedFileName;
    if (transcribeData.duration > 0 && transcribeData.ID !== '') {
      let usageSum = Math.round(transcribeData.duration / 60 * 100) / 100;    //minutes
      if (usageSum < 1) usageSum = 1;
      let endTime = endTimeOfAudio;
      let realtimeBoolValue = realTimeFlag;
      let url = transcribeData.url;
      let transcribeID = transcribeData.ID;
      let inputValue = transcribeData.inputValue;
      let noteIDnum = transcribeData.noteIDnum;
      setAudioName(audiofilenameofCloud);
      // console.log('inputValue', inputValue);
      createHistory(inputValue, usageSum, endTime, realtimeBoolValue, transcribeID, url, noteIDnum);
      // console.log('NoteIDnum:', noteIDnum);
      setTranscribeData ({ ID: '', url: '', inputValue: '', noteIDnum: '', duration: 0 });
      setDuration(0);
    }
    return () => {
      if (delaySet) clearTimeout(delaySet);
    };
  }, [transcribeData, createHistory]);

  // useEffect(() => {
  //   if (error) {
  //     // console.error('Error:', error);
  //     if(error === 'Transcription failed'){

  //     }
  //   }
  // }, [error]);

  const updateTranscription = (newText, id, url, videoURL, videoID, title, noteIDnum, duration, subtitleWithTimestamp) => {
    setTranscription({
      text: newText || '',
      transcribeID: id || '',
      url: url || '',
      videoURL: videoURL || '', 
      videoID: videoID || '',
      title: title || '',
      noteIDnum: noteIDnum || '',
      duration: duration || 0,
      subtitleWithTimestamp: subtitleWithTimestamp || '',
    });
  };

  //2025.02.23
  const calculateFileHash = async (file) => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        const sparkMD5 = require('spark-md5');
        const hash = sparkMD5.ArrayBuffer.hash(e.target.result);
        resolve(hash);
      };
      reader.readAsArrayBuffer(file);
    });
  };

  const handleUploadResumeMode = async (file, noteIDnum, retryCount = 0) => {
    try {
      const fileHash = await calculateFileHash(file); // 获取文件的唯一标识（哈希值）
      // console.log('fileHash', fileHash);
      const totalChunks = Math.ceil(file.size / CHUNK_SIZE); // 计算文件分片总数
      // 检查哪些分片已经上传
      const { data: checkData } = await axios.post(
        '/api/check',
        {
          fileName: file.name,
          fileHash,
        },
      );

      // 用 Set 存储已上传分片索引，便于查找
      const uploadedChunks = new Set(checkData.uploadedChunks || []);

      // 上传未完成的分片
      for (let chunkIndex = 0; chunkIndex < totalChunks; chunkIndex++) {
        if (uploadedChunks?.has(chunkIndex)) {
          console.log('Pass chunkIndx', chunkIndex);
          setProgressOfUpload(((chunkIndex + 1) / totalChunks) * 100); // 更新进度
          continue; // 跳过已经上传的分片
        }
        console.log('Upload chunkIndx: ', chunkIndex, 'Total chunks: ', totalChunks);
        // 创建当前分片
        const start = chunkIndex * CHUNK_SIZE; // 分片起始字节
        const end = Math.min(file.size, start + CHUNK_SIZE); // 分片结束字节
        const chunk = file.slice(start, end); // 获取分片
        let success = false;
        let attempts = 0;

        // 对每个分片重试上传
        while (!success && attempts < MAX_RETRY) {
          try {
            // 上传分片
            const formData = new FormData();
            // formData.append('chunk', chunk); // 当前分片
            formData.append('fileName', file.name); // 文件名
            formData.append('fileHash', fileHash); // 文件唯一标识
            formData.append('chunkIndex', chunkIndex); // 分片索引
            formData.append('chunk', chunk);

            await axios.post(
              `/api/upload?fileHash=${fileHash}&chunkIndex=${chunkIndex}&fileName=${file.name}`,
              formData,
              {
                onUploadProgress: (progressEvent) => {
                  const chunkProgress = progressEvent.loaded / progressEvent.total;
                  const overallProgress = ((chunkIndex + chunkProgress) / totalChunks) * 100;
                  setProgressOfUpload(overallProgress);
                },
              },
            );
            // 上传成功后标记该分片
            uploadedChunks.add(chunkIndex);
            success = true;
          } catch (err) {
            attempts++;
            console.error(`Upload of chunk ${chunkIndex} failed for ${attempts} times:`, err);
            // 重试前延时（可采用指数退避）
            await new Promise(resolve => setTimeout(resolve, 1000 * attempts));
          }
        }
        if (!success) {
          alert(`Chunk ${chunkIndex} upload failed, please check the network and try again!`);
          uploading.current = false;
          return;
        }
      }

      // 通知服务端合并分片
      const mergeResponse = await axios.post('/api/merge', {
        fileName: file.name,
        fileHash,
        totalChunks,
        userid: user.uid, 
        noteIDnum
      });

      // console.log('Upload successfully, url is:', mergeResponse.data.url);
      return mergeResponse.data.url;
    } catch (err) {
      console.error('Error in uploading chunks: ', err);
      if (retryCount < MAX_RETRY) {
        console.log(`Retrying handleUploadResumeMode, attempt ${retryCount + 1}`);
        return handleUploadResumeMode(file, noteIDnum, retryCount + 1);
      } else {
        console.error('Max retry attempts reached. Upload failed.');
        return null;
      }
    }
  };

  const handleUpload = async (waveBuffer, durationtime, noteIDnumFromParent) => {
    updateTranscription('', '', '', '', '', '', '', 0, '');
    setTranscribeData ({ ID: '', url: '', inputValue: '', noteIDnum: '', duration: 0 });
    const usageSum = Math.round(durationtime / 60 * 100) / 100;
    setError('');

    let noteIDnum = '';

    if(endTimeOfLocalSave) {
      setEndTimeOfAudio(endTimeOfLocalSave);
      noteIDnum = gereatedUniqueNoteID();
    } else {
      setEndTimeOfAudio(Date.now());
      noteIDnum = gereatedUniqueNoteID();
    }

    if(noteIDnumFromParent && noteIDnumFromParent !== ''){
      noteIDnum = noteIDnumFromParent;
      console.log('noteIDnumFromParent:', noteIDnum);
    }

    const formData = new FormData();
    // const fileName = `${user.uid}-_-${waveBuffer.name}`;
    const fileName = waveBuffer.name;
    // console.log('fileName:', fileName);
    formData.append('audio', waveBuffer, fileName);

    // 添加检查：确保 formData 包含 audio 字段
    if (!formData.get('audio')) {
      setError('FormData is missing the audio field.');
      console.error('FormData check failed: missing audio field.');
      return { audioUrl: null, noteIDnum: noteIDnum };
    }
    
    await checkToken();
    console.log('Start uploading audio file...');
    setUploading(true);

    // 添加超时配置（单位：毫秒）
    const uploadTimeout = durationtime * 1000 * 2; // 2倍音频时长
    const cancelToken = axios.CancelToken.source();

    // 添加超时计时器
    const timeoutId = setTimeout(() => {
      cancelToken.cancel('Upload timeout');
    }, uploadTimeout);

    let response = null;
    let urlTemp = '';
    try {
      if(true) {
        urlTemp = await handleUploadResumeMode(waveBuffer, noteIDnum);
      } else {
        response = await axios.post('/api/upload', formData, {
          cancelToken: cancelToken.token,
          timeout: 0, // 禁用默认超时
          // headers: {
          //   'Content-Type': 'multipart/form-data'
          // },
          onUploadProgress: (progressEvent) => {
            // 保持心跳机制
            if (progressEvent.bytesSent % 5000000 === 0) { // 每5MB发送心跳
              cancelToken.cancel(); // 取消当前请求
              // 重新发起上传（需要实现断点续传）
            }
          },
        });
      }

      clearTimeout(timeoutId);
      // setUrl(response.data.url);
      setProgressStatus('Done');
      // console.log('Audio upload done, it\'s url is:', response?.data?.url || urlTemp);
      setUploading(false);
      setError('');
      setUploadedFileName(response?.data?.url.split('/').pop() || urlTemp?.split('/').pop() || '');

      const audioName = urlTemp.split('/').pop() || waveBuffer.name;
      let audioUrl = urlTemp;
      if (!urlTemp.includes(noteIDnum)) audioUrl = await handleRenameUploadedAudioFile(audioName, noteIDnum);  
      return {
        audioUrl: audioUrl,
        noteIDnum: noteIDnum 
      };
    } catch (err) {
      if (axios.isCancel(err)) {
        console.log('Upload cancelled:', err.message);
      }
      setError('Error uploading the file');
      console.error('Error uploading the file, error detail is: ', err);
      setUploading(false);
      setProgressStatus('Failed');
      setUploadedFileName('');
      return {
        audioUrl: null,
        noteIDnum: noteIDnum
      };
    }
  };

  const handleDeleteUploadedAudioFile = async (audioFileName) => {
    if (!audioFileName) {
      console.error('No file to delete');
      return;
    }

    try {
      const userid = user.uid;
      const filename = uploadedFileName;
      const response = await axios.delete(`/api/upload/${userid}/${filename}`);
      // console.log ('Delete uploaded audio file successfully!', response.data.message);
      // setUrl(null);
      setError('');
    } catch (err) {
      console.error(err);
    }
  };

  const handleRenameUploadedAudioFile = async (audioFileName, newNameWithNoteID) => {
    if (!audioFileName) {
      console.error('Fiel not exist.');
      return;
    }

    const filename = audioFileName;
    const newFilename = newNameWithNoteID;
    const userid = user.uid;

    try {
      const response = await axios.put(`/api/upload/rename/${userid}/${filename}`, {
        newFilename
      });
      // console.log ('Delete uploaded audio file successfully!', response.data.message);
      // setUrl(null);
      // console.log(response.data.message);
      // console.log(response.data.newFilename); //newFilename+extension
      return response.data.url;
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  //_______________________________________________________________________________________
  //_____________________batch transcribe__________________________________________________
  const startBatchTranscribe = async (url, id, inputValue, noteIDnum, duration) => {
    setError('');
    setProgressStatus('Transcribing');
    console.log('Start transcribe...');
    setProgressOfTranscription(5);
    setIsTranscribing(true);
    try {
      if(!id){
        const response = await axios.post('/api/startTranscription', { url, noteIDnum: noteIDnum, uid: user.uid, language: userDataLocal?.Language.code, duration: duration }, { timeout: 5000 });
        const transcriptionId = response.data.transcriptionId;
        // console.log('transcriptionId:', transcriptionId);
        // console.log('response:', response);
        if (transcriptionId) {
          // console.log('inputValue', inputValue);
          setTranscribeData ({ ID: transcriptionId, url: url, inputValue: inputValue || '', noteIDnum: noteIDnum || '', duration: duration });
          checkTranscriptionStatus(transcriptionId, url, '', '', '', noteIDnum, duration);
        } else {
          setError('Transcription ID is undefined.');
          setIsTranscribing(false);
        }
      } else {
        // checkTranscriptionStatus(id, url);
      }
    } catch (error) {
      setError('Error starting transcription');
      setIsTranscribing(false);
    }
  }

  const checkTranscriptionStatus = async (id, url, videoURL, videoID, title, noteIDnum, duration) => {
    let timeoutId;
    const useremail = userDataLocal?.Email;
    const currentTaskInfo = {id: id, url: url, email: useremail, duration: duration, endTime: endTimeOfAudio, realtimeValue: realTimeFlag, videoURL: videoURL, videoID: videoID, title: title, noteIDnum: noteIDnum};
    const addORDelete = true;
    updateTaskIDOfOfflinetranscribe(currentTaskInfo, addORDelete);
    try {
      const response = await axios.get('/api/checkTranscriptionStatus', { 
        params: { id, uid: user.uid, noteIDnum }, 
        timeout: 5000 
      });
      if (response.data.status === 'Succeeded') {
        // console.log('Succeeded! Transcription is:', response.data.transcriptionText);
        const newText = response.data.transcriptionText;
        const subtitleWithTimestamp = response.data.subtitleWithTimestamp;
        updateTranscription(newText, id, url, videoURL, videoID, title, noteIDnum, duration, subtitleWithTimestamp);
        setProgressOfTranscription(100);
        setProgressStatus('Done');
        if(id !== noteIDnum && id.includes('-')){
          handleDeleteTranscription(id);
        }
        
        // if (url) {
        // const audioFileName = url.split('/').pop();
        // handleDeleteUploadedAudioFile(audioFileName);
        // } else {
        //   console.log('URL is undefined');
        // }
        setTimeout(() => {
          setIsTranscribing(false);
        }, 100);
        // setSumOFUploadedFiles(oldValue => oldValue + 1);
        if (timeoutId) clearTimeout(timeoutId);
      } else if (response.data.status === 'Failed') {
        setError('Transcription failed');
        console.error('Transcription failed, error or response.data is:', response.data.properties.error || response.data);
        // console.log('The uri is:', url);
        setIsTranscribing(false);
        if (timeoutId) clearTimeout(timeoutId);
      } else {
        setProgressOfTranscription(prev => Math.min(prev + 5, 95));
        timeoutId = setTimeout(() => checkTranscriptionStatus(id, url, videoURL, videoID, title, noteIDnum, duration), 5000);
      }
    } catch (error) {
      // 如果捕获到的错误是超时错误，则认为转写还在处理中，继续轮询
      if (error.code === 'ECONNABORTED') {
        setProgressOfTranscription(prev => Math.min(prev + 5, 95));
        timeoutId = setTimeout(() => {
          checkTranscriptionStatus(id, url, videoURL, videoID, title, noteIDnum, duration);
        }, 5000);
      } else {
        console.error('Error checking transcription status:', error);
        setError('Error checking transcription status');
        setIsTranscribing(false);
        setProgressStatus('Failed');
      }
    }
  };

  const updateTaskIDOfOfflinetranscribe = async (taskInfo, addORDelete) => {
    //addORDelete: true is add, false is delete
    const id = taskInfo.id;
    setTaskIDOfOfflinetranscribe((prevBuffer) => {
      const taskExists = prevBuffer.some((item) => item.id === id);
  
      if (taskExists) {
        // 如果存在该元素
        if(addORDelete){
          //如果已存在该元素，且是添加操作，则什么都不做
          return prevBuffer;
        } else {
          //如果已存在该元素，且是删除操作，则删除该元素
          return prevBuffer.filter((item) => item.id !== id);
        }
      } else {
        // 如果不存在该元素
        if(addORDelete){
          //如果不存在该元素，且是添加操作，则添加该元素
          return [...prevBuffer, taskInfo];
        } else {
          //如果不存在该元素，且是删除操作，则什么都不做
          console.log('The task is not exist in the taskIDOfOfflinetranscribe buffer, so it can not be deleted.');
          return prevBuffer;
        }
      }
    });
  };

  const handleDeleteTranscription = async (id) => {
    try {
      const response = await axios.delete(`/api/deleteTranscription/${id}`);
      // console.log ('Delete Transcription tast from  microsoft successfully!',response.data.message);
      setError('');
      
      const useremail = userDataLocal?.Email;
      const currentTaskInfo = {id: id, email: useremail};
      const addORDelete = false;
      updateTaskIDOfOfflinetranscribe(currentTaskInfo, addORDelete);

    } catch (err) {
      setError('Error deleting transcription');
      console.error(err);
    }
  };

  const gereatedUniqueNoteID = () => {
    let index = 0;
    if (userDataLocal?.History) {
      index = userDataLocal?.History?.length;
    }

    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    const milliseconds = String(now.getMilliseconds()).padStart(3, '0');
  
    const dateNumbers = `${year}${month}${day}`;
    const timeNumbers = `${hours}${minutes}${seconds}${milliseconds}`;
    const indexString = String(index).padStart(7, '0');

    return `${dateNumbers}${timeNumbers}${indexString}`;
  }

  useImperativeHandle(ref, () => ({
    async processAudio(file, inputValue, noteIDnumFromParent) {
      // console.log('audioBlob', file);
      console.log('Processing offline transcribe...');
      setRealTimeFlag(realtimeValue);
      try {
        // const waveBuffer = await preCheckAudioFile(file);
        const durationtime = await getAudioDuration(file);
        const usageSum = Math.round(durationtime / 60 * 100) / 100;
        // console.log('durationtime:', durationtime);
        setDuration(Math.floor(durationtime));

        const { audioUrl, noteIDnum } = await handleUpload(file, durationtime, noteIDnumFromParent);
        await checkToken();
        // console.log('inputValue', inputValue);
        // console.log('audioUrl is:', audioUrl);
        console.log('noteIDnum is:', noteIDnum);  
        if (audioUrl && audioUrl.startsWith('http') && (audioUrl.includes('metaspringai') || audioUrl.includes('nvoice'))) {
          let id = null;
          startBatchTranscribe(audioUrl, id, inputValue || '', noteIDnum, durationtime);
        } else {
          if((audioUrl || audioUrl !== '') && audioUrl?.includes('localhost')){
            console.log('The audio file is saved locally, so it can not be transcribed by batch transcribe.');
          } else {
            //音频文件上传失败，将音频文件存储在本地以备后续再次尝试处理
            console.error('Error uploading the file');
            if(inputValue && !noteIDnumFromParent){
              createHistory(inputValue, usageSum, Date.now(), realtimeValue, 'Failed', '', noteIDnum);
            } 
            saveAudioLocally(file, inputValue, noteIDnum);
          }
        }
        // const duration = await getAudioDuration(audioBlob);
      } catch (error) {
        console.error('Error processing audio:', error);
      }
    },
    async resumeCheckTranscribeID(url, id, duration, endTime, realtimeValue, videoURL, videoID, title, noteIDnum) {
      // console.log('audioBlob', file);
      console.log('Resume CheckTranscribeID...');
      setRealTimeFlag(realtimeValue);
      setUploadedFileName(url.split('/').pop());
        // console.log('durationtime:', durationtime);
      setDuration(duration);
      setEndTimeOfAudio(endTime);
      try {
        setTimeout(() => {
          checkTranscriptionStatus(id, url, videoURL, videoID, title, noteIDnum, duration);
        },500);
      } catch (error) {
        console.error('Error processing audio:', error);
      }
    },
  }));

  return null;
});

export default OfflineTranscription;

const getAudioDuration = (file) => {
  return new Promise((resolve) => {
      const audio = document.createElement('audio');
      audio.src = URL.createObjectURL(file);
      audio.addEventListener('loadedmetadata', () => {
          resolve(audio.duration);
      });
  });
};
